<template>
  <div class="contact">
  <h1 class="contact-title">お問い合わせ</h1>
  <div class="contact-container">
    <p class="contact-maintext">!下記のお問い合わせは店舗に直接お問い合わせください!</p>
    <ul class="text-block">
      <li class="contact-list">ご予約に関する内容<br>
      (ご予約・またはご予約内容の変更・キャンセル・ご予約状況の確認<br>
      店舗到着時間の遅刻連絡など予約、施術に関すること)</li>
      <li class="contact-list">施術内容の確認・メニューの詳細など</li>
      <li class="contact-list">店舗スタッフの採用に関して</li>
    </ul>
    <div class="contact-form">
      <p class="form-text">その他のお問い合わせは下記よりお願いいたします。</p>
      <p class="kome">※メールアドレスをクリックすると、メールソフトが起動いたします。</p>
      <a class="mail" href="mailto: info@enrikekukan.com?subject=【セルフエステエンリケ】WEBからのお問合せ&body=お問合せ内容をご記入ください：">info@enrikekukan.com</a>
    
      <p class="contact-lasttext">※お問い合わせ内容によっては返信までお時間をいただく場合がございます。<br>
      ※お問い合わせ内容によっては、こちらからお問い合わせをいただいても店舗から直接<br>
      連絡を差し上げる場合がございます。</p>
    </div>
  </div>
  </div>
</template>

<script>


export default {
  name: 'app',
  components: {
      // なし
  },
  data: function(){
      return {
      hoge:'',
      huga:{key:'',a:''},
      }
  },
}
</script>

<style scoped>
  @import "../../css/style.css";
  .contact{
    width: 100%;
  }

  .contact-title{
      color: var(--main-color);
      text-align: center;
      margin: 50px auto;
      font-size: 2.5rem;
      
  }

  .contact-container{
    width:70vw;
    margin: 50px auto;
    
    
  }

  .contact-maintext{

    font-size:2rem;
    text-align: center;
    font-weight: 600;
  }

  .text-block{
    display: block;
    padding:80px;
    background: rgba(6,142,160,0.17);
    margin-top: 30px;

  }

  .contact-list{
    display: block;
    list-style: none;
    margin-bottom:1em;
    line-height: 1.3em;
    font-weight: 600;
    font-size:23px;
  }

  .form-text{
    color: var(--main-color);
    
    font-size:1.5rem;
    margin-top: 50px;
    font-weight: 600;
    
  }

  .kome{

    margin: 5px 0;
    
  }

  .kome,.form-text{

    vertical-align:left;
    
    
  }

  .mail{

    
    font-size:3vmax;

    color: #000;
    font-weight: 100;
    letter-spacing:6px;
    margin: 20px 0;

  }

  .mail:hover{

    opacity: 0.5;
    transition: 0.5s  ease-in-out;
  }

  .mail:visited{

    color: #000;
  }

.contact-lasttext{

  line-height: 1.5em;
  margin-bottom:100px;
}

.contact-form{

  width: 50vw;
  margin: 0 auto;
}

/*スマホ表示 */

@media(max-width:821px){

  .contact-container{

    width:90vw;
  }

  .contact-title{

    font-size: 5vw;
    letter-spacing: 0.2em;
  }

  .text-block{

    padding:20px;
  }

  .contact-list{

    font-size:15px;
  }

  .contact-maintext{

    font-size:15px;
  }

  .contact-form{

    width:90vw;
  }

  .form-text{

    font-size:15px;
  }

  .kome,.contact-lasttext{
    font-size:13px;

  }

  .mail{

    letter-spacing: 1px;
    color: #000;
  }
}
</style>